

















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import revisionAccessModule, {
  activeKey
} from "@/store/modules/RevisionAccessStore";
import { appModule } from "@/store/modules/app";

@Component
export default class AjukanAksesRevisiDialog extends Vue {
  @Prop({ required: true }) registerNo!: string;
  @Prop({ type: String, default: "" }) documentType!: string;
  @Prop({ type: [Number, String], default: null }) documentId!:
    | number
    | string
    | null;
  @Prop({ type: String, default: "" }) documentLabel!: string;
  @Prop({ type: String, default: "Ajukan Akses Revisi" }) buttonLabel!: string;
  @Prop({
    type: String,
    default:
      "Rekam medis kunjungan ini sudah terkunci. Untuk mengubah data atau melakukan verifikasi, ajukan akses revisi."
  })
  keterangan!: string;

  dialog = false;
  reason = "";
  submitting = false;
  formValid = false;

  rules = {
    reason: [
      (v: string) => !!v || "Alasan wajib diisi.",
      (v: string) =>
        (v && v.trim().length >= 10) ||
        "Alasan minimal 10 karakter.",
      (v: string) =>
        (v && v.trim().length <= 2000) ||
        "Alasan maksimal 2000 karakter."
    ]
  };

  get docId(): number | null {
    const n = Number(this.documentId);
    return this.documentType && n > 0 ? n : null;
  }

  get isDocument(): boolean {
    return !!this.docId;
  }

  get scope() {
    return {
      register_no: this.registerNo,
      document_type: this.docId ? this.documentType : undefined,
      document_id: this.docId || undefined
    };
  }

  get snapshot() {
    return revisionAccessModule.activeByRegister[
      activeKey(this.registerNo, this.documentType, this.docId)
    ];
  }

  get pending() {
    return this.snapshot?.pending ?? null;
  }

  @Watch("dialog")
  onDialogChange(open: boolean) {
    if (open && this.registerNo) {
      revisionAccessModule.fetchActive(this.scope);
    }
  }

  async submit() {
    if (!this.formValid) return;
    if (!this.registerNo) {
      appModule.NoticeDelay("Nomor register tidak tersedia. Muat ulang halaman.");
      return;
    }
    this.submitting = true;
    try {
      await revisionAccessModule.submitRequest({
        ...this.scope,
        reason: this.reason.trim()
      });
      appModule.NoticeDelay("Pengajuan revisi terkirim. Menunggu persetujuan.");
      this.reason = "";
      this.dialog = false;
      this.$emit("submitted");
    } catch (e) {
      // ErrorAlert sudah ditampilkan service
    } finally {
      this.submitting = false;
    }
  }

  close() {
    this.dialog = false;
  }

  formatDate(iso: string): string {
    if (!iso) return "";
    const m = moment(iso);
    return m.isValid() ? m.format("DD-MM-YYYY HH:mm") : iso;
  }
}
